<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <strong>Адреса начала работы курьеров в Москва-Сити</strong>
                </CCardHeader>

                <CCardBody>
                    <table class="table">
                        <thead>
                            <th>Отображение</th>
                            <th>Показывать</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    Статус
                                </td>
                                <td>
                                    <CSwitch
                                        :checked.sync="queueSettings.status"
                                        name="dayEnabled"
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Выполняет
                                </td>
                                <td>
                                    <CSwitch
                                        :checked.sync="queueSettings.orderIds"
                                        name="dayEnabled"
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Находится в
                                </td>
                                <td>
                                    <CSwitch
                                        :checked.sync="queueSettings.now_at"
                                        name="dayEnabled"
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Направляется в
                                </td>
                                <td>
                                    <CSwitch
                                        :checked.sync="queueSettings.go_to"
                                        name="dayEnabled"
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Время последнего обновления
                                </td>
                                <td>
                                    <CSwitch
                                        :checked.sync="queueSettings.updated"
                                        name="dayEnabled"
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-2"
                        @click="saveData"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        @click="goBack"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>
<script>
    export default {
        name: 'TowerTime',

        data: () => ({
            queueSettings: {
                status: false,
                orderIds: false,
                now_at: false,
                go_to: false,
                updated: false,
            }
        }),

        computed: {},

        mounted() {
            this.updateData();
        },

        methods: {
            async updateData() {
                try {
                    const { data } = await this.axios.get('/couriers/service/courier-queue');
                    this.queueSettings = data?.id ? data : this.queueSettings;
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            async saveData() {
                try {
                    await this.axios.post('/couriers/service/courier-queue', this.queueSettings);
                    this.$router.push({ path: '/courier-service' });
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            goBack() {
                this.$router.push({ path: '/courier-service' });
            }
        },
    };
</script>
